import axios from "axios";

const isDev = process.env.NODE_ENV === "development";

const api = axios.create({
  baseURL: isDev ? "/api/" : "https://test.phpvue.cn/api/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("user_id");
    if (token) {
      config.headers["Token"] = token;
    }
    if (userId) {
      config.headers["user_id"] = userId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const weixinApi = axios.create({
  baseURL: isDev
    ? "https://test.phpvue.cn/api/"
    : "https://test.phpvue.cn/api/",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export const qiandao = (data) => {
  return api.post("setqiandao/qiandao", data);
};

export const weixinlog = (data) => {
  return api.post("login/weixinlog", data);
};

export const weixinCallback = (accesstoken) => {
  return weixinApi.get("login/getloginfo", {
    params: { accesstoken },
  });
};

export const getAddress = (location) => {
  return api.get("map/getmapaddress", {
    params: { location },
  });
};
export const getclassroom = (classroomid) => {
  return api.get("setqiandao/getclassroomdata", {
    params: { classroomid },
  });
};

export const getWechatJsConfig = (url) => {
  return api.get("wechat/getJsConfig", {
    params: { url },
  });
};
export default api;
